<template>
  <div class="page full">
    <div id="order-view">
      <!-- <div class="headerTips flex">
        <div class="tips-content">
          若产生等候费/高速费/停车费/搬运费，需另行支付
        </div>
        <div class="more-rules"></div>
      </div> -->
      <div class="order-info-box">
        <div class="flex-sb">
          <div class="time">
            <span style="font-size: 14px;line-height: 32px; margin-right: 8px">下单时间</span>
            <span style="font-size: 12px;line-height: 32px;">{{orderInfo.createTime}}</span>
          </div>
          <div class="order-state" v-if="orderStatusName[orderInfo.orderStatus]">{{ orderStatusName[orderInfo.orderStatus] }}</div>
        </div>
        <div class="address">
          <div class="start flex" v-for="(startItem,startIndex) in shippingList" :key="'start'+startIndex">
            <div class="start-line">
              <div class="dot"></div>
              <div class="line"></div>
            </div>
            <div class="address-info" style="flex:1;">
              <div class="address-title">{{startItem.title}}</div>
              <div class="address-detail">
                {{startItem.detailedAddress}}
              </div>
              <div class="address-user">
                <span>{{startItem.name}}</span>
                <span>{{startItem.phone}}</span>
              </div>
              <div class="transport-info" v-if="startItem.transportInfo">
								<div class="">需要装货：</div>
								<div style="margin-left: auto;">{{startItem.transportInfo}}</div>
							</div>
            </div>
          </div>
          <div class="end flex" v-for="(endItem,endIndex) in revecingList" :key="'end'+endIndex">
            <div class="end-line">
              <div class="dot"></div>
              <div class="line" v-if="endIndex != revecingList.length-1"></div>
            </div>
            <div class="address-info">
              <div class="address-title">送至 {{endItem.title}}</div>
              <div class="address-detail">
                {{endItem.detailedAddress}}
              </div>
              <div class="address-user">
                <span>{{endItem.name}}</span>
                <span>{{endItem.phone}}</span>
              </div>
              <div class="transport-info" v-if="endItem.transportInfo">
								<div class="">需要装货：</div>
								<div style="margin-left: auto;">{{endItem.transportInfo}}</div>
							</div>
            </div>
          </div>
        </div>
        <div class="car-info-box flex">
          <div class="car-img">
            <!-- <img :src="carImage" style="display:inline-block;width:100%;height:100%;" alt=""> -->
            <van-image
              width="123px"
              height="82px"
              :src="carImage"
              v-if="carImage"
            />
          </div>
          <div class="car-info flex">
            <div style="font-size: 14px; font-weight: bold">
              {{carInfo}}
            </div>
            <div style="font-size: 12px" v-if="cargoInfo">
              {{cargoInfo}}
            </div>
          </div>
        </div>
        <div class="form-field" style="margin-bottom: 28px">
          <div class="field">订单编号：</div>
          <div class="content" @click="handleCopy">
            <span style="color: #c9c2bb; font-size: 14px"
              >{{orderInfo.orderNo}}</span
            >
            <span
              style="width: 1px; margin: 4px 8px; background-color: #c9c2bb"
            ></span>
            <span style="color: #3d3833; font-size: 14px">复制</span>
          </div>
        </div>
        <!-- 已付部分   COLLECT_ON_DELIVERY:到付   ONLINE:线上支付 -->
        <div v-if="orderInfo.payType === 'COLLECT_ON_DELIVERY' && orderInfo.firstPaymentPaid === '1' && orderInfo.lastPaymentPaid === '1'" style="margin-bottom: 16px;">
          <div class="form-field" style="margin-bottom: 8px">
            <div class="field">订单已支付：</div>
            <div
              class="content flex"
              style="align-items: flex-end; color: #3D3833"
            >
              <span style="font-size: 12px; line-height: 12px">￥</span>
              <span style="font-size: 18px; font-weight: bold; line-height: 18px"
                >{{zeroPadding(orderInfo.totalAmountIn)}}</span
              >
            </div>
          </div>
          <div class="cost-details flex" @click="showChargeDetailsPopup('total')">
            <span>收费明细</span>
            <span class="right-icon"></span>
          </div>
        </div>
        <div v-else-if="orderInfo.payType === 'ONLINE' && orderInfo.firstPaymentPaid === '1' && orderInfo.lastPaymentPaid === '0'" style="margin-bottom: 16px;">
          <div class="form-field" style="margin-bottom: 8px">
            <div class="field">订单已支付：</div>
            <div
              class="content flex"
              style="align-items: flex-end; color: #3D3833"
            >
              <span style="font-size: 12px; line-height: 12px">￥</span>
              <span style="font-size: 18px; font-weight: bold; line-height: 18px"
                >{{zeroPadding(orderInfo.firstOrderAmountIn)}}</span
              >
            </div>
          </div>
          <div class="cost-details flex" @click="showChargeDetailsPopup('first')">
            <span>收费明细</span>
            <span class="right-icon"></span>
          </div>
        </div>
        <div v-else-if="orderInfo.payType === 'ONLINE' && orderInfo.firstPaymentPaid === '1' && orderInfo.lastPaymentPaid === '1'" style="margin-bottom: 16px;">
          <div class="form-field" style="margin-bottom: 8px">
            <div class="field">订单已支付：</div>
            <div
              class="content flex"
              style="align-items: flex-end; color: #3D3833"
            >
              <span style="font-size: 12px; line-height: 12px">￥</span>
              <span style="font-size: 18px; font-weight: bold; line-height: 18px"
                >{{zeroPadding(orderInfo.totalAmountIn)}}</span
              >
            </div>
          </div>
          <div class="cost-details flex" @click="showChargeDetailsPopup('total')">
            <span>收费明细</span>
            <span class="right-icon"></span>
          </div>
        </div>
        <!-- 未付部分 -->
        <div v-if="orderInfo.payType === 'COLLECT_ON_DELIVERY' && orderInfo.firstPaymentPaid === '0' && orderInfo.lastPaymentPaid === '0'">
          <div class="form-field" style="margin-bottom: 8px">
            <div class="field">待支付：</div>
            <div
              class="content flex"
              style="align-items: flex-end; color: #ec892e"
            >
              <span style="font-size: 12px; line-height: 12px">￥</span>
              <span style="font-size: 18px; font-weight: bold; line-height: 18px"
                >{{zeroPadding(orderInfo.totalAmountIn)}}</span
              >
            </div>
          </div>
          <div class="cost-details flex" @click="showChargeDetailsPopup('total')">
            <span>收费明细</span>
            <span class="right-icon"></span>
          </div>
        </div>
        <div v-if="orderInfo.payType === 'ONLINE' && orderInfo.firstPaymentPaid === '0' && orderInfo.lastPaymentPaid === '0' && orderInfo.orderStatus == 'WAIT_FOR_PAYMENT'">
          <div class="form-field" style="margin-bottom: 8px">
            <div class="field">待支付：</div>
            <div
              class="content flex"
              style="align-items: flex-end; color: #ec892e"
            >
              <span style="font-size: 12px; line-height: 12px">￥</span>
              <span style="font-size: 18px; font-weight: bold; line-height: 18px"
                >{{zeroPadding(orderInfo.firstOrderAmountIn)}}</span
              >
            </div>
          </div>
          <div class="cost-details flex" @click="showChargeDetailsPopup('first')">
            <span>收费明细</span>
            <span class="right-icon"></span>
          </div>
        </div>
        <div v-else-if="orderInfo.payType === 'ONLINE' && orderInfo.firstPaymentPaid === '1' && orderInfo.lastPaymentPaid === '0' && orderInfo.lastOrderAmountIn != '0'">
          <div class="form-field" style="margin-bottom: 8px">
            <div class="field">{{orderInfo.lastOrderAmountIn>0?'待支付：':'退款'}}</div>
            <div
              class="content flex"
              style="align-items: flex-end; color: #ec892e"
            >
              <span style="font-size: 12px; line-height: 12px">￥</span>
              <span style="font-size: 18px; font-weight: bold; line-height: 18px"
                >{{zeroPadding(Math.abs(orderInfo.lastOrderAmountIn))}}</span
              >
            </div>
          </div>
          <div class="cost-details flex" @click="showChargeDetailsPopup('last')">
            <span>收费明细</span>
            <span class="right-icon"></span>
          </div>
        </div>
        <div class="dash-line" v-if="orderInfo.orderStatus == 'WAIT_FOR_PAYMENT'"></div>
        <button class="submit-btn" v-if="orderInfo.orderStatus == 'WAIT_FOR_PAYMENT'" @click="handleSubmit" :disabled="isDisabled">点击支付订单</button>
      </div>
    </div>
    <div id="public-web-container" class="hidden">
      <p class="">正在打开 “小蜂蜂闪运”...</p>
      <a
        id="public-web-jump-button"
        href="javascript:"
        class="weui-btn weui-btn_primary weui-btn_loading"
        onclick="openWeapp()"
      >
        <span
          id="public-web-jump-button-loading"
          class="weui-primary-loading weui-primary-loading_transparent"
          ><i class="weui-primary-loading__dot"></i
        ></span>
        打开小蜂蜂闪运小程序
      </a>
    </div>
    <!-- 跳转小程序的开放标签。文档 https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/Wechat_Open_Tag.html -->
    <div id="wechat-web-container" class="hidden">
      <p class="">点击以下按钮打开 “小蜂蜂闪运”</p>
      <!-- <wx-open-launch-weapp
        id="launch-btn"
        username="gh_f005ce663d53"
        path="pages/login/index"
      >
        <template>
          <button
            style="
              width: 200px;
              height: 45px;
              text-align: center;
              font-size: 17px;
              display: block;
              margin: 0 auto;
              padding: 8px 24px;
              border: none;
              border-radius: 4px;
              background-color: #07c160;
              color: #fff;
            "
          >
            打开小蜂蜂闪运小程序
          </button>
        </template>
      </wx-open-launch-weapp> -->
    </div>
    <van-popup v-model="isShowQrcode" round>
      <div id="desktop-web-container" class="hidden">
        <div id="qrcode"></div>
        <div class="">请在手机端打开网页链接</div>
      </div>
    </van-popup>
    <charge-details-popup ref="chargeDetailsPopup" />
    <input type="text" id="copyInput" style="display:none;">
  </div>
</template>
<script>
import { Image as VanImage } from 'vant';
import { apigetAppOrderInfo , apigetVipAppOrderInfo , apigetLink } from '@/api/salesperson/index.js'
import { Toast,Popup } from 'vant';
import QRCode from 'qrcodejs2';
import chargeDetailsPopup from "./components/charge-details-popup.vue";
import { $math } from "@/utils/math.js";
export default {
  components:{VanImage,chargeDetailsPopup},
    data(){
        return {
            orderInfo:{},
            loadingWay:{
              '1':'散货',
              '2':'卡板',
              '3':'箱子'
            },
            weightDirction:{
              '1':'吨',
              '2':'板',
              '3':'箱'
            },
            isDisabled:false,
            isShowQrcode:false,
            priceDirction:{
              'mileageFeeIn':'运输费用',
              'invoiceFee':'发票税费',
              'insurancePremium':'货损险',
              'tollFeeIn':'路桥费',
              'loadingPointFeeIn':'装货点多点费',
              'shippingWaitCostIn':'装货等候费',
              'unloadingPointFeeIn':'卸货点多点费',
              'unloadingWaitCostIn':'卸货等候费',
              'shippingCostIn':'装货费',
              'unloadingCostIn':'卸货费',
              'intoTheWareshouseFeeIn':'入仓费',
              'weighingFeeIn':'过磅费',
              'covidTestFeeIn':'核酸费',
              'parkingFeeIn':'停车费',
              'declareCustomsFeeIn':'报关费',
              'carSiteStationFeeIn':'场站费',
              'otherFeeIn':'其他费用',
              'userLoadingUnloadingFeeIn':'装卸货费用',
              'driverLoadingUnloadingFeeIn':'装卸货费用'
            },
            costList:[],
            // 订单状态
            orderStatusName:{
              "CANCEL":"已取消",
              "REFUNDED":"已取消",
              "WAIT_FOR_PICKUP":"待取货",
              "COMPLETE":"已完成",
              "WAIT_FOR_PAYMENT":"待支付",
              "TRANSPORTING":"运输中",
              "WAIT_FOR_DISPATCH":"待调度",
              "WAIT_FOR_ORDER":"待接单"
            },
            pricePayFirst:{
              'mileageFeeIn':'运输费用',
              'firstInvoiceFeeIn':'发票税费',
              'insurancePremium':'货损险',
              'userLoadingUnloadingFeeIn':'装卸货费用'
            },
            pricePayLast:{
              'tollFeeIn':'路桥费',
              'loadingPointFeeIn':'装货点多点费',
              'shippingWaitCostIn':'装货等候费',
              'unloadingPointFeeIn':'卸货点多点费',
              'unloadingWaitCostIn':'卸货等候费',
              'shippingCostIn':'装货费',
              'unloadingCostIn':'卸货费',
              'intoTheWareshouseFeeIn':'入仓费',
              'weighingFeeIn':'过磅费',
              'covidTestFeeIn':'核酸费',
              'parkingFeeIn':'停车费',
              'declareCustomsFeeIn':'报关费',
              'carSiteStationFeeIn':'场站费',
              'otherFeeIn':'其他费用',
              'invoiceFee':'发票税费',
              'driverLoadingUnloadingFeeIn':'装卸货费用'
            },
            shippingList:[],//装货地址
				    revecingList:[],//卸货地址
        }
    },
    provide(){
      return {
        zeroPadding: this.zeroPadding,
        math: $math
      }
    },
    created(){
      this.init();
      document.addEventListener('visibilitychange',this.handleVisiable);
    },
    computed:{
      cargoInfo(){
        if(!this.orderInfo.cargoInfo)return '';
        let cargoInfo = cargoInfo ? JSON.parse(this.orderInfo.cargoInfo) : {};
        let size = cargoInfo.size ? cargoInfo.size.split('*') : [];
        return `${cargoInfo.cargoName?cargoInfo.cargoName:'未知货物'}
        ${this.loadingWay[cargoInfo.loadingWay]?'，'+this.loadingWay[cargoInfo.loadingWay]:''}
        ${cargoInfo.weight?'，'+cargoInfo.weight+'吨':''}
        ${cargoInfo.cargoNumber?'，'+cargoInfo.cargoNumber:''}
        ${cargoInfo.cargoNumber?'，'+this.weightDirction[cargoInfo.loadingWay]:''}
        ${size.length ? '，长'+size[0].replace('m','')+'米/宽'+size[1].replace('m','')+'米/高'+size[2].replace('m','') :''}`
      },
      carInfo(){
        if(!this.orderInfo.carAttributePojo)return '';
        let carTypeLength = this.orderInfo.carAttributePojo.carSpecs ? this.orderInfo.carAttributePojo.carSpecs.split("*")[0] : "";
        let carTypeName = this.orderInfo.carAttributePojo.carTypeName ? this.orderInfo.carAttributePojo.carTypeName : "";
        return `${carTypeLength}${carTypeName?"-"+carTypeName:""}`;
        // return this.orderInfo.carAttributePojo.carType + ' ' +this.orderInfo.carAttributePojo.carTypeName;
      },
      carImage(){
        if(!this.orderInfo.carAttributePojo)return '';
        return this.orderInfo.carAttributePojo.carPicture;
      }
    },
    destroyed(){
      document.removeEventListener('visibilitychange',this.handleVisiable)
    },
    methods:{
        init(){
          this.getOrderInfo(this.$router.currentRoute.query.accessCode);
        },
        async getOrderInfo(code){
          try {
            if(!code) return Toast.fail({ type:'fail', message:'暂无相关订单信息，请返回重试' , duration:3000 });
            let res = null;
            if(this.$route.query.orderSource === 'app') res = await apigetAppOrderInfo({accessCode:code});
            else if(this.$route.query.orderSource === 'app_vip') res = await apigetVipAppOrderInfo({accessCode:code});
            res.data.shippingInfo = res.data.shippingInfo?JSON.parse(res.data.shippingInfo):[];
            res.data.receivingInfo = res.data.receivingInfo?JSON.parse(res.data.receivingInfo):[];
            this.orderInfo = res.data?res.data:{};
  
            this.shippingList = [];
            this.revecingList = [];
            res.data.shippingInfo.map((shipItem,shipIndex)=>{
              this.shippingList.push({
                title:`${shipItem.province?shipItem.province:''}${shipItem.city ? shipItem.city:''}${shipItem.district?shipItem.district:''}${shipItem.title?shipItem.title:''}${shipItem.remark ? shipItem.remark:''}`,
                phone:shipItem.phone,
                name:shipItem.name,
                detailedAddress:shipItem.detailedAddress,
                transportInfo:'',
                needCarry:'',
              })
            })
            res.data.receivingInfo.map((receItem,receIndex)=>{
              this.revecingList.push({
                title:`${receItem.province?receItem.province:''}${receItem.city ? receItem.city:''}${receItem.district?receItem.district:''}${receItem.title?receItem.title:''}${receItem.remark ? receItem.remark:''}`,
                phone:receItem.phone,
                name:receItem.name,
                detailedAddress:receItem.detailedAddress,
                transportInfo:'',
                needCarry:'',
              })
            })
            if(res.data.userLoadingUnloadingInfo && res.data.userLoadingUnloadingInfo !== '[]' && res.data.userLoadingUnloadingInfo !== 'null'){
              let userLoadingUnloadingInfoData = JSON.parse(res.data.userLoadingUnloadingInfo);
              let shippingIndex = 0;
              let receivingIndex = 0;
              userLoadingUnloadingInfoData.map((mapItem,mapIndex)=>{
                if(mapItem.addrType === 'shipping'){
                let typeInfo = '';
                // 需要装卸货的时候才处理数据
                if(mapItem.needCarry){
                  mapItem.items.map(childItem=>{
                  if(childItem.itemType === 'complete'){
                    // 散货
                    typeInfo = `${childItem.bulkCargoItemType==='complete'?'整车':'半车'}散货 ${childItem.itemNumber>0?'大件货*'+childItem.itemNumber:''}`
                  }else{
                    // 卡板/箱子
                    typeInfo += `${childItem.itemType === 'box'?(childItem.itemNumber>0?'箱子*'+childItem.itemNumber:''):''}`;
                    typeInfo += `${childItem.itemType === 'pallet'?(childItem.itemNumber>0?'卡板*'+childItem.itemNumber:''):''}`;
                  }
                  })
                }
                let layoutInfo = mapItem.floorInfo.carryType === 'none'?'不用上楼':mapItem.floorInfo.carryType === 'elevator'?'全程电梯':mapItem.floorInfo.carryType === 'floor'?mapItem.floorInfo.floorNumber+'楼-楼梯':'';
                  
                this.shippingList[shippingIndex].needCarry = mapItem.needCarry;
                this.shippingList[shippingIndex].transportInfo = mapItem.needCarry?typeInfo +' '+layoutInfo:'';
                shippingIndex ++;
                }else if(mapItem.addrType === 'receiving'){
                let typeInfo = '';
                // 需要装卸货的时候才处理数据
                if(mapItem.needCarry){
                  mapItem.items.map(childItem=>{
                  if(childItem.itemType === 'complete'){
                    // 散货
                    typeInfo = `${childItem.bulkCargoItemType==='complete'?'整车':'半车'}散货 ${childItem.itemNumber>0?'大件货*'+childItem.itemNumber:''}`
                  }else{
                    // 卡板/箱子
                    typeInfo += `${childItem.itemType === 'box'?(childItem.itemNumber>0?'箱子*'+childItem.itemNumber:''):''}`;
                    typeInfo += `${childItem.itemType === 'pallet'?(childItem.itemNumber>0?'卡板*'+childItem.itemNumber:''):''}`;
                  }
                  })
                }
                let layoutInfo = mapItem.floorInfo.carryType === 'none'?'不用上楼':mapItem.floorInfo.carryType === 'elevator'?'全程电梯':mapItem.floorInfo.carryType === 'floor'?mapItem.floorInfo.floorNumber+'楼-楼梯':'';
        
                this.revecingList[receivingIndex].needCarry = mapItem.needCarry;
                this.revecingList[receivingIndex].transportInfo = mapItem.needCarry?typeInfo +' '+layoutInfo:'';
                receivingIndex ++;
                }
              })
            }
  
            let list = Object.keys(this.priceDirction);
            let resultList = [];
            list.map(item=>{
              resultList.push({
                name:this.priceDirction[item],
                value:res.data[item]?res.data[item]:0,
              })
            })
            this.costList = resultList;
          } catch (error) {
            console.log("getOrderInfo error",error);
          }
        },
        // 提交订单
        async handleSubmit(){
          this.docReady();
        },
        // 获取链接
        getLink(){
          return apigetLink({
            accessCode:this.$router.currentRoute.query.accessCode,
            orderSource: this.$route.query.orderSource
          }).then(res=>{
            if(res.data.errcode == 0){
              location.href = res.data.url_link;
            }else{
              Toast.fail('生成链接失败，请重试')
            }
          })
        },
        // 格式化app订单来源
        appTypeFormat(orderSource){
          let arr = orderSource.split("_");
          if(arr.length === 1) return orderSource;

        },
        // 复制订单号
        handleCopy(){
          const input = document.createElement('input')
          input.setAttribute('value', this.orderInfo.orderNo)
          document.body.appendChild(input)
          input.select()
          document.execCommand('Copy')
          document.body.removeChild(input)
          Toast.success('复制成功')
        },
        handleVisiable(e){
          switch (e.target.visibilityState) {
            case 'hidden':
              
              break;
            case 'visible':
              this.init();
              break;
          
            default:
              break;
          }
        },
        async docReady() {
            var ua = navigator.userAgent.toLowerCase()
            var isWXWork = ua.match(/wxwork/i) == 'wxwork'
            var isWeixin = !isWXWork && ua.match(/micromessenger/i) == 'micromessenger'
            var isMobile = false
            var isDesktop = false
            if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|IEMobile)/i)) {
                isMobile = true
            } else {
                isDesktop = true
            }

            // if (isWeixin) {
            //     var containerEl = document.getElementById('wechat-web-container')
            //     containerEl.classList.remove('hidden')
            //     containerEl.classList.add('full', 'wechat-web-container')

            //     var launchBtn = document.getElementById('launch-btn')
            //     launchBtn.addEventListener('ready', function (e) {
            //         console.log('开放标签 ready')
            //     })
            //     launchBtn.addEventListener('launch', function (e) {
            //         console.log('开放标签 success')
            //     })
            //     launchBtn.addEventListener('error', function (e) {
            //         console.log('开放标签 fail', e.detail)
            //     })

            //     wx.config({
            //         // debug: true, // 调试时可开启
            //         appId: 'wx9b09f0695738f1e9',
            //         timestamp: 0, // 必填，填任意数字即可
            //         nonceStr: 'nonceStr', // 必填，填任意非空字符串即可
            //         signature: 'signature', // 必填，填任意非空字符串即可
            //         jsApiList: ['chooseImage'], // 必填，随意一个接口即可 
            //         openTagList: ['wx-open-launch-weapp'], // 填入打开小程序的开放标签名
            //     })
            // } else 
            if (isDesktop) {
                // 在 pc 上则给提示引导到手机端打开
                this.isShowQrcode = true;
                this.$nextTick(()=>{
                  var containerEl = document.getElementById('desktop-web-container')
                  containerEl.classList.remove('hidden')
                  containerEl.classList.add('full', 'desktop-web-container')
                  document.getElementById('qrcode').innerHTML = '';
                  // 生成当前页面二维码
                  new QRCode('qrcode', {
                    text: document.URL,
                    width: 200,
                    height: 200,
                    colorDark: '#000000',
                    colorLight: '#ffffff',
                    correctLevel: QRCode.CorrectLevel.H
                  });
                })
            }else{
              this.isDisabled = true;
              await this.getLink();
              this.isDisabled = false;
            }
            // else {
            //     var containerEl = document.getElementById('public-web-container')
            //     containerEl.classList.remove('hidden')
            //     containerEl.classList.add('full', 'public-web-container')
            //     var buttonEl = document.getElementById('public-web-jump-button')
            //     var buttonLoadingEl = document.getElementById('public-web-jump-button-loading')
            //     try {
            //         await openWeapp(() => {
            //             buttonEl.classList.remove('weui-btn_loading')
            //             buttonLoadingEl.classList.add('hidden')
            //         })
            //     } catch (e) {
            //         buttonEl.classList.remove('weui-btn_loading')
            //         buttonLoadingEl.classList.add('hidden')
            //         throw e
            //     }
            // }
        },
        // 补零
        zeroPadding(num){
          if(!num) return 0;
          num = num+"";
          let pointArr = num.split(".");
          if(pointArr.length === 1) return `${num}.00`;
          return `${pointArr[0]}.${pointArr[1].length >= 2 ? pointArr[1] : pointArr[1] + "0"}`
        },
        /**
         * @description 显示收费明细
         * @param {first|last|total} type 要展示的费用项 
         */
        showChargeDetailsPopup(type){
          let costList = [];
          let amountIn = "0.00";
          if(type === 'first') {
            costList = this.priceDirctionKeyList(this.pricePayFirst,'first');
            amountIn = this.orderInfo.firstOrderAmountIn;
          }else if(type === 'last') {
            costList = this.priceDirctionKeyList(this.pricePayLast,'last');
            amountIn = this.orderInfo.lastOrderAmountIn;
          }else if(type === 'total') {
            costList = [...this.priceDirctionKeyList(this.pricePayFirst,'first'),...this.priceDirctionKeyList(this.pricePayLast,'last')];
            amountIn = this.orderInfo.totalAmountIn;
          };
          this.$refs["chargeDetailsPopup"].show({
            orderInfo: this.orderInfo,
            costList,
            amountIn,
            type
          })
        },
        // type: first 首款 ， last 尾款
        priceDirctionKeyList(data,type){
          if(!data || !this.orderInfo) return [];
          let resultList = Object.keys(data).map(keyName => {
            let newItem = {
              label: data[keyName],
              keyName,
              value: this.zeroPadding(this.orderInfo[keyName])
            };
            // invoiceFee 表示总发票费，所以如果展示尾款费用时需要把首款发票费减掉
            if(type === "last" && keyName === "invoiceFee") newItem.value = this.zeroPadding(+$math(this.orderInfo.invoiceFee,this.orderInfo.firstInvoiceFeeIn).subtract());
            // driverLoadingUnloadingFeeIn 表示司机申报上来的装卸货费，需要将首款已收的装卸货费减去，如果司机未申报装卸货费用，取driverLoadingUnloadingFeeIn字段，金额为0
            if(type === "last" && keyName === "driverLoadingUnloadingFeeIn") newItem.value = this.orderInfo.driverLoadingUnloadingDeclare === 1?this.zeroPadding(+$math(this.orderInfo.driverLoadingUnloadingFeeIn,this.orderInfo.userLoadingUnloadingFeeIn).subtract()):this.orderInfo.driverLoadingUnloadingFeeIn;
            return newItem;
          })
          return resultList.filter(keyName => keyName.value)
        },
    }
}
</script>

<style lang="scss" scoped>
.hidden {
  display: none;
}
.page {
  background-color: #f8f8f8;
}
.flex {
  display: flex;
}
.full {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.public-web-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.public-web-container p {
  position: absolute;
  top: 40%;
}

.public-web-container a {
  position: absolute;
  bottom: 40%;
}

.wechat-web-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.wechat-web-container p {
  position: absolute;
  top: 40%;
}

.wechat-web-container wx-open-launch-weapp {
  position: absolute;
  bottom: 40%;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.desktop-web-container {
  width: 400px;
  height: 400px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 99999;
}

.desktop-web-container p {
  position: absolute;
  top: 40%;
}
.headerTips {
  padding: 6px 12px;
  background-color: #ffdbb9;
  font-size: 12px;
  align-items: center;
}
.headerTips .tips-content {
  color: #ec892e;
  margin-right: auto;
}
.headerTips .more-rules {
  width: 56px;
  height: 12px;
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHAAAAAYCAYAAAAiR3l8AAAJFUlEQVRoQ+2ae4xUdxXHP+fOzi6EdUGkKQYathINRCol1VRDSXntztwRtT7w1VoUJFpNpSpYEVKwBWmgFCqaBm1LbG3RYl9S5wUsRERCSCwNNJAQFWMVTWlpC6Ts7Mw95ve7d2bnzs7MDi2QhXj/2uz93d/re873nPM9I/z/uaRvQAbK7nX27Ihs2VIYKPu5VPYxIADUzs4hSFMKtB3YTlvr/LcLpk6fPorooN0GAMkk3zeQgNCYeysiv0L5+/namwWwNPH5PK3qHMmkHu1vyhJ4whTgFF4+Ltnsn8u/U9dtkVSqu7+57FmmJ8bQzDELYDoZMlCNJR5B+Fq/8yg7JZOcHtpDLNGFMK2Bb2uCc9kBqLHYByGyBWF8AxezmULuNtm+/Y16YwcSgFoEPTDmCwZgv5cXDNB4Qu2fDXpXrXmNR+GxAJHlwOCG1lfdS1vrlGrUqrHYRCRyU7C3YYjcEcxp5veffG49keZ1gQcul3Tyx5XrajyxDFhOPQ+scXbtcG8kIrvK6fGiA6gzZlxJU3Os5oUa/vYB/CXwp6rjRE9LOv10tXcmUeHN0zeDLEV4vz9GN+AVFks2eyZEWXbsmc0Is4GT5JgkXcl/VJ23GFvqWUKOdqIsKwdQXfdGVKaiHJBM8rlzAbDPtxcIQI27O1EZQTcdsiv5n8ojhmNEcRMNuUSNQTUCdECXWxGuDr48iKd34OgEck1PSdfz/yrO6BtSi6HWmnExBHZHx2Sc6Dz7P6EVLOigbOr1wO5FNLWsCQHY63GbJJOce04AVn57oQCMJQ4iTEA5QjfTKkGsBeBJ4IEqEAWUpM+AvBh+rxNBPl0vw9KYezfIF0FX0Nb6eMjD8L5uPFdjic8j/Ay4AngFL39TZVJTz74ajIGWQssAG7gATk2MpIWdCOOqgVgdwFpeVCcGNhKgLYUaJwnqvSAWbkBkfkCnB0GuCf7eT05m16LNWiBebgBaIqkDYg0A9TgeX+pzSSZIm8fzVqGSCb0XjeE4i8+lxvFj4pmbQNchclUw3ylUVwCDEBkM3l5Jp3/fKKtfjgD6ILqjGST7gZHlnnjRYmApvs2cOZSmJpM8zELEZI6GKs3zFuhD9ORWEm35QonCVZdIJvWTurTZGV+NOCPqxkCv52EbJ/068JKh0FCs7+wch9O0MwRiOBkIUmGT9Z3HGOgX6xGTQHwUZQIi0dK6qv8EHiKf28jw4Sd448waHL4b0OhxkI19wFMOSyb5ZMkoYom/lSVH1bFWnQMytQLAe4CloPdJOrVoICYxlYfRMIiHLloM1Jj7CCK+CqIcRXgej2clm/yj/df0WaOIeo81pHb4NP4NyaZ/Yb+NJRYgDAtALyVTCH7ZYwcVnoWIGdfrgbHEowhfQXWhZFJrL0EAD1y0LNTGpijX08O+8sSkrKhfCrzLZp5gvC5fYX1NwAJ/jB4n3zO+miqjne4SHFmB8ex87iOyY8d/yzy1KKUFFOr+BWQSWrgTx3kAlR82WsiXwEY3SDr1nYtRyFd4n19W1KDQRnOGvuMaFGotcKrzUGdhL/3pVnKR28prwtLlxxP3Q5Favc/WFAtiiSeQIAFTDpPvniI7drwaeOqnEK5FdBe53CGiLSdKBzCFfou228Le845JNt3rvb6X+1poSRYLvNfTpZJNrbzQANpMdJDuBxldO4npVWKKakxZpinx4GLeQvWbNRGuo8TYSzRrRJuXgNwCvLtEqRSMB14BkVfK45v9phw8z1sl2fSPaq2vxXhowDMaq7KbtiHTKiU4jSe+B6wtB7BeydIHwHjgvfjGdCEBbLiMsJfV6c7FkYfLOwM23T912qA/CfQZSac+8/Zd1Frzk1YiM5eM3usX9afvRGSlnddjDUOHLOa114YRbd4E8gkfaN0kmdTc2uBZTfSAzWh7uq+mqWWv9W71HpNM+taSN5ukyokcBXmvn/0ymBztRQCr9Sa1Mz4Hx2m3sVTkLDhH7Hw93SNt8vXqmdE081WU1yWTtCLI+dBC64Fn1qjaDyxdsGnv4N0CMhPkdrvhQs8Nsm3bnncEoCklJHq9bEtlQxRuvEL1XpulqlUfJpTKDNV7JJO6q966vZ7qG5l2uJNxzDwSDSU9cfen/nn0BVRet9RYDmAs/gTIAcmkVldbr5SQKdsQDqE6Di3M7qPndridOIykhz3SlfprI2JH5XoaS7xgab8RKa1koWEhuXfOBi7xHQFrm7EtmxDpKM1jkpGCzpft6bBwULGQT80thy0tK5+TTPKpgH5Xo8wi3z3NJDTaGZ+H4zzkG6NOxREjcIcB9OmxXdLJ4VUu1Eh9vw2o/2bLIEaEMGzSg1ufhs+9oauxRApor6aD1vZA1x1LQeYhujBUsxmL9fQ5cHbi5V7srzfXH5i+EvPmdeBMBVPYW/G6+JxEdT1aWFtp2dW9okTLR2kbMj4k13VHRpjEKBT3VJdJJnV3ieZCHuj+G+S0ZJIfCDGE0WnRX/sM4dNyYDjbgGtsdqxeh2QyL9Xw3AvUkZ/ujqVZJ6IyBWFGrx4Z1GzoLsQmHeHenepx4BjCCVROgJ5FxE/bPc1DYb25fFvIa+RaInolKqYbMRb4MCKGIivmtMmHKewfbtRAQsAUvI/LtnQydPEzZryHppYHg9aUebVO0kmTxJg4lUXowPO+jcpLODIK4XHQrZJOfdKO8ZO7VWV17G407xYNq8+vCrTwMQOipfCICT/Bo0y2a6EHJZ36UH8G3sj72j+pMNmb6kaGtv7GWHOwSZOGz0L1hjLtstY6myWd/LK9ACufNRvFxdR5fR/TrFXdgejvJJOp6HLUP0agp5p4OQXVByWT+lYIPF8F2o/IeFR7rIxWJs1pzL0LkT7N3fKmtcbdp22nxR5GN6GF2/vEu97f9ZylrdW1d2ZCQvOgl/ucwGONZJM/aASg/saUkhg/MDMMT9Pkc3+Qrq5Sf67qnRtQHGccImPAuQqRVpQx/lg1gut9kk11lYwv5hrVZJb1WDhi21GqB6GwrxGKrHeQQKr7Pm2tK6t27Ds7r0Oa1qH5RZLN7gsBXGwyi2UG/yno3vIEyzfA6GPk9ef1YrEd5zj58vPYe0XaET2N8jLKnqJT9AdOI+//B/XPtncrfh/pAAAAAElFTkSuQmCC");
  background-size: 100% auto;
}
.order-info-box {
  background-color: #ffffff;
  box-shadow: 0px 3px 6px 1px rgba(204, 181, 159, 0.1);
  border-radius: 4px;
  margin: 8px 12px;
  padding: 14px 16px;
}
.order-info-box .time {
  color: #ec892e;
}
.order-info-box .address {
  background-color: #f8f8f8;
  border-radius: 4px;
  padding: 12px 8px;
}
.address-info {
  margin-left: 8px;
}
.address-info .address-title {
  font-size: 16px;
  color: #3d3833;
  font-weight: bold;
  line-height: 16px;
  margin-bottom: 5px;
}
.address-info .address-detail {
  font-size: 12px;
  color: #c9c2bb;
}
.address-info .address-user {
  font-size: 14px;
  color: #3d3833;
}
.address-info .transport-info {
  width: 100%;
  display: flex;
  align-items: center;
  background-color: #ffffff;
  box-sizing: border-box;
  padding: 5px 16px;
  margin-top: 5px;
  border-radius: 4px;
  color: #C9C2BB;
  font-size: 14px;
}
.address .start-line {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.address .start-line .dot {
  width: 9px;
  height: 9px;
  background-color: #ec892e;
  border-radius: 50%;
}
.address .start-line .line {
  width: 1px;
  background-color: #ec892e;
  flex: 1;
}
.address .end-line {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.address .end-line .dot {
  width: 7px;
  height: 7px;
  background-color: #f8f8f8;
  border: 1px solid #ec892e;
  border-radius: 50%;
}
.address .end-line .line {
  width: 1px;
  background-color: #ec892e;
  flex: 1;
}
.address .start .address-info,.address .end .address-info {
  padding-bottom: 32px;
}
.car-info-box {
  margin-bottom: 8px;
}
.car-info-box .car-img {
  width: 123px;
  height: 82px;
}
.car-info-box .car-info {
  flex: 1;
  margin-left: 16px;
  color: #3d3833;
  flex-direction: column;
  justify-content: center;
}
.form-field {
  display: flex;
  align-items: center;
}
.form-field .field {
  color: #3d3833;
  font-size: 14px;
}
.form-field .content {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}
.cost-details {
  color: #c9c2bb;
  font-size: 12px;
  align-items: center;
  justify-content: flex-end;
}
.cost-details .right-icon {
  display: block;
  width: 0;
  height: 0;
  border: 4px solid #c9c2bb;
  position: relative;
  margin-left: 4px;
  transform: rotate(130deg);
}
.cost-details .right-icon::after {
  content: "";
  width: 7px;
  height: 7px;
  display: block;
  position: absolute;
  top: -2px;
  left: -2px;
  background-color: #ffffff;
}
.dash-line {
  border-bottom: 1px dashed #c9c2bb;
  margin: 16px 0;
}
.submit-btn {
  width: 100%;
  height: 48px;
  color: #ffffff;
  background-color: #ec892e;
  border-radius: 8px;
  border: none;
  font-size: 16px;
}
.submit-btn:focus {
  outline: none;
}
.popup {
  padding: 16px;
  .price {
    margin-top: 12px;
  }
  .popup-title {
    font-size: 16px;
  }
  .tips {
    font-size: 12px;
    margin-top: 12px;
  }
  .detailsBox {
    background-color: #F8F8F8;
    border-radius: 4px;
    padding: 24px 16px;
    margin-top: 10px;
    max-height: 300px;
    overflow-y: auto;
  }
  .details-title {
    align-items: center;
    color: #393939;
    font-size: 16px;
  }
  .details-content {
    font-size: 12px;
    color: #C9C2BB;
  }
  .details-line {
    border-bottom: 1px solid #EBE5E0;
    margin: 16px 0;
  }
}
.flex-sb {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.order-state {
  font-size: 16px;
  line-height: 32px;
  font-weight: bold;
  color: #EC892E;
}
</style>